export const categories = [
  {
    id: 1,
    name: '明星爆料',
    slug: 'mingxing-baoliao',
    description: '最新明星动态、恋情曝光、人设崩塌等劲爆内容',
    icon: 'ri-user-star-line',
    count: 128,
  },
  {
    id: 2,
    name: '圈内黑料',
    slug: 'quannei-heiliao',
    description: '娱乐圈幕后交易、潜规则、行业内幕深度揭秘',
    icon: 'ri-spy-line',
    count: 96,
  },
  {
    id: 3,
    name: '最新丑闻',
    slug: 'zuixin-chouwen',
    description: '最新曝光的丑闻事件，出轨、吸毒、偷税漏税等',
    icon: 'ri-alert-line',
    count: 87,
  },
  {
    id: 4,
    name: '娱乐八卦',
    slug: 'yule-bagua',
    description: '明星日常八卦、综艺节目幕后花絮、片场趣事',
    icon: 'ri-chat-smile-2-line',
    count: 156,
  },
  {
    id: 5,
    name: '综艺内幕',
    slug: 'zongyi-neimu',
    description: '热门综艺节目内幕、选手关系、剪辑黑幕揭秘',
    icon: 'ri-tv-2-line',
    count: 64,
  },
  {
    id: 6,
    name: '影视揭秘',
    slug: 'yingshi-jiemi',
    description: '电影电视剧制作内幕、演员片酬、剧组八卦',
    icon: 'ri-film-line',
    count: 73,
  },
];

export const hotTags = [
  '顶流塌房', '出轨实锤', '偷税漏税', '综艺黑幕', '恋情曝光',
  '片酬揭秘', '人设崩塌', '潜规则', '选秀内定', '合同纠纷',
  '假唱翻车', '整容实锤',
];